// import api from './apiMock';

import api from './apiRest';

export default api;